import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { cloneDeep, sortBy } from 'lodash';
import { ITicketType } from '../../../../interfaces/ticket-type.interface';
import { CreateLocalChecklistDialogComponent } from '../create-local-checklist-dialog/create-local-checklist-dialog.component';
import { IChecklist } from '../../../../interfaces/checklist.interface';
import { HDTicketTypesToken } from '../../check-lists.constant';
import { CreateChecklistParams } from '../check-lists/check-lists.component';
import { ISelectableTicketType } from '../../../../interfaces/selectable-ticket-type.interface';

@Component({
  selector: 'app-check-lists-local',
  templateUrl: './check-lists-local.component.html',
  styleUrls: ['./check-lists-local.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckListsLocalComponent implements OnInit {
  @Input() hdTicketTypes: ITicketType[] = [];
  @Input() checklists: IChecklist[] = [];

  @Output() created: EventEmitter<CreateChecklistParams> = new EventEmitter<CreateChecklistParams>();
  @Output() selected: EventEmitter<IChecklist> = new EventEmitter<IChecklist>();
  @Output() changed: EventEmitter<void> = new EventEmitter<void>();

  selectedHDChecklist: IChecklist;
  selectedHDTicketTypes: ITicketType[];
  form: UntypedFormGroup;

  cloneDeep = cloneDeep;

  constructor(
    private modalService: NgbModal,
    private controlContainer: ControlContainer,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.form = this.controlContainer.control as UntypedFormGroup;
  }

  sortBySelected(items: ISelectableTicketType[]): ISelectableTicketType[] {
    return sortBy(items, (item: ISelectableTicketType) => !item.checked);
  }

  handleChangeTicketType(hdTicketTypes: ITicketType[]): void {
    this.selectedHDTicketTypes = hdTicketTypes;
    this.form.patchValue({
      hdTicketTypes: hdTicketTypes.map((tt) => tt.id),
    });
    this.changed.emit();
  }

  handleChangeHDChecklist(selectedHDChecklist: IChecklist): void {
    this.hdTicketTypes = this.hdTicketTypes.map((tt) => ({
      ...tt,
      checked: false,
    }));
    this.selectedHDChecklist = selectedHDChecklist;
    this.selected.emit(selectedHDChecklist);
    this.selectedHDTicketTypes = selectedHDChecklist ? selectedHDChecklist.hd_ticket_types.map((ticketTypeId) => this.hdTicketTypes.find((tt) => tt.id === ticketTypeId)) : [];

    this.form.patchValue({
      hdTicketTypes: this.selectedHDTicketTypes.map((tt) => tt.id),
    });
  }

  openCreateLocalChecklist(): void {
    const clearedTicketTypes = Array.isArray(this.hdTicketTypes)
      ? cloneDeep(this.hdTicketTypes).map((tt) => ({
          ...tt,
          checked: false,
        }))
      : [];

    const createDialog = this.modalService.open(CreateLocalChecklistDialogComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
      injector: Injector.create({
        providers: [
          {
            provide: HDTicketTypesToken,
            useValue: clearedTicketTypes,
          },
        ],
        parent: this.injector,
      }),
    });

    createDialog.result.then((result?: CreateChecklistParams) => {
      if (!result) {
        return;
      }

      this.created.emit(result);
    });
  }
}
